module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "Insurer",
      "label": "Insurance Policy"
    }
  }, [_c('insurance-policy', {
    attrs: {
      "row-data": _vm.rowData,
      "site-id": _vm.rowData.site_id,
      "site-name": _vm.siteName
    }
  })], 1), _vm._v(" "), (_vm.isManager('finance')) ? _c('el-tab-pane', {
    attrs: {
      "name": "statement",
      "label": "Statement"
    }
  }, [_c('insurance-statement', {
    attrs: {
      "rowData": _vm.rowData,
      "site-id": _vm.rowData.site_id,
      "site-name": _vm.siteName
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.rowData.updated_at) ? _c('div', [_c('hr'), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v("Last update: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.rowData.updated_at)))]), (_vm.rowData.updated_by) ? _c('span', [_vm._v(" by " + _vm._s(_vm.rowData.updated_by))]) : _vm._e()])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e0ce7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/details/InsuranceDetails.vue
// module id = 1487
// module chunks = 0